import { useNavigate, useParams } from 'react-router';

import { FormikHelpers } from 'formik';

import { usePermissionsContext } from 'context/PermissionsContext';
import { useFormMutation } from 'mutations/useFormMutation';
import { LojaConfiguracao, LojaRequest } from 'pages/cadastro/loja/types';

const formatLojaConfiguracoes = (value: LojaConfiguracao[] = []): LojaConfiguracao[] => {
    return value.filter((item) => item.dsValor);
};

export function useMutateDadosBasicos() {
    const { mutate, isLoading } = useFormMutation();
    const { hasPermission } = usePermissionsContext();
    const navigate = useNavigate();
    const { id } = useParams();

    const onSubmit = (values: LojaRequest, formik: FormikHelpers<LojaRequest>) => {
        const formData = structuredClone(values);

        formData.lojaConfiguracoes = formatLojaConfiguracoes(formData.lojaConfiguracoes);

        mutate(
            {
                url: '/gestao/loja',
                idField: 'idLoja',
                formData,
                formik,
                preventRedirect: true,
            },
            {
                onSuccess: (response: any) => {
                    const hasPermissionAlterar = hasPermission(['LOJA_ALTERAR']);

                    formik.resetForm({ values: response.data.data });

                    setTimeout(() => {
                        if (hasPermissionAlterar && !id) {
                            navigate(`/cadastro/loja/form/${response.data.data.idLoja}`);
                        } else if (!hasPermissionAlterar) {
                            navigate(-1);
                        }
                    }, 50);
                },
            },
        );
    };

    return { onSubmit, isLoading };
}
